import { PortfolioRiskApi } from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE } from "../../constants/constants";
import { IGlobalPeriodContext, useGlobalPeriod } from "../context";
import moment from "moment";
import { Period } from "@iliotech/generated-api-v3";

export const useScatter = (
  portfolioId: string,
  options?: any,
  overridePeriod?: IGlobalPeriodContext
) => {
  const api = new PortfolioRiskApi(undefined, `${API_BASE}/api`);
  const { period } = overridePeriod || useGlobalPeriod();
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;

  return useQuery(
    [`scatter-data`, { portfolioId, from, to }],
    () => api.getScatter(portfolioId, undefined, from!, to!),
    options
  );
};
